import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getCursoTipoMonedaListSuccess(cursotipomoneda) {
  return {type: types.LOAD_CURSOTIPOMONEDA_LIST_SUCCESS, cursotipomoneda};
}



export function getCursoTipoMonedaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoTipoMonedaApi.getCursoTipoMonedaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(cursotipomoneda => {                  
                  dispatch(getCursoTipoMonedaListSuccess(cursotipomoneda));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCursoTipoMonedaSuccess(catalogo) {
  return {type: types.LOAD_CURSOTIPOMONEDA_SUCCESS, catalogo};
}

export function getCursoTipoMoneda(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().CursoTipoMonedaApi.getCursoTipoMoneda(id, token).then(cursotipomoneda => {   
        dispatch(getCursoTipoMonedaSuccess(cursotipomoneda));
        return cursotipomoneda;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(cursotipomoneda) {
  return {type: types.SAVE_CURSOTIPOMONEDA_SUCCESS, cursotipomoneda};
}


export function save(cursotipomoneda, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoTipoMonedaApi.save(cursotipomoneda, token).then(cursotipomonedaGuardado => {   
    dispatch(saveSuccess(cursotipomonedaGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getCursoTipoMonedaComboSuccess(datos) {
  return {type: types.GET_CURSOTIPOMONEDAS_COMBO_SUCCESS, datos};
}

export function getCursoTipoMonedaCombo(idCurso, token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().CursoTipoMonedaApi.getCursoTipoMonedaCombo(idCurso,token).then(datos => {   
        
      dispatch(getCursoTipoMonedaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



export function borrarSuccess(cursotipomoneda) {
  return {type: types.BORRAR_CURSOTIPOMONEDA_SUCCESS, cursotipomoneda};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoTipoMonedaApi.borrar(id, token ).then(cursotipomoneda => {
               
                  dispatch(borrarSuccess(cursotipomoneda));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(cursotipomoneda) {
  return {type: types.ACTIVAR_CURSOTIPOMONEDA_SUCCESS, cursotipomoneda};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoTipoMonedaApi.activar(id, token).then(cursotipomoneda => {
               
                  dispatch(activarSuccess(cursotipomoneda));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CURSOTIPOMONEDA, filtro};
}



